import { FC } from "react";
import { MiIcon } from "@miplatform/components";
import { MiTHEME } from "@miplatform/theme";
import {
  mdiCheckCircle,
  mdiCloseCircle,
  mdiLockOutline,
  mdiRadioboxBlank,
  mdiRadioboxMarked,
} from "@mdi/js";

const ICON_SIZE = 0.75;

export const VerticalTabStatusIcon: FC<IConfigTabStatusIconProps> = ({
  hasErrors,
  isComplete,
  isLocked,
  selected,
}) => {
  if (isLocked) {
    return (
      <MiIcon
        path={mdiLockOutline}
        size={ICON_SIZE}
        color={MiTHEME.palette.grey.main}
        data-testid="config-tab-status-icon"
      />
    );
  }

  if (selected) {
    return (
      <MiIcon
        path={mdiRadioboxMarked}
        size={ICON_SIZE}
        color={MiTHEME.palette.primary.main}
        data-testid="config-tab-status-icon"
      />
    );
  }

  if (isComplete) {
    return (
      <MiIcon
        path={mdiCheckCircle}
        size={ICON_SIZE}
        color={MiTHEME.palette.success.main}
        data-testid="config-tab-status-icon"
      />
    );
  }

  if (hasErrors) {
    return (
      <MiIcon
        path={mdiCloseCircle}
        size={ICON_SIZE}
        color={MiTHEME.palette.error.main}
        data-testid="config-tab-status-icon"
      />
    );
  }

  if (isComplete !== undefined || hasErrors !== undefined) {
    return (
      <MiIcon
        path={mdiRadioboxBlank}
        size={ICON_SIZE}
        color={MiTHEME.palette.grey.main}
        data-testid="config-tab-status-icon"
      />
    );
  }

  return null;
};

interface IConfigTabStatusIconProps {
  hasErrors?: boolean;
  isComplete?: boolean;
  isLocked?: boolean;
  selected?: boolean;
}
